import React from 'react';
import PropTypes from 'prop-types';
import { handleClickLinks } from "../includes/utils";
import CsfFournisseurRecognitionRenewalTitle
  from "../includes/csf-fournisseur-recognition-renewal-title";

export function FournisseurRecognitionRequestStepFourConfirmBlock({hasPreviousRenewalEndDate, currentStep, onStepChange, accessToken, apiUrl, apiEnv, user, form, urlActivityDetail, urlHome }) {

  const urlParams = new URLSearchParams(window.location.search);
  const isRenewal = (urlParams.get('renewal') === 'true' || hasPreviousRenewalEndDate);

  return (
    <main className="fournisseur recognition">

      <h1 id="step6">{window.Drupal.t('fournisseur.creation_form.confirmation.draft.title')}</h1>

      <CsfFournisseurRecognitionRenewalTitle
        isRenewal={isRenewal || hasPreviousRenewalEndDate}
        formData={form} />

      <div className="content">
        <div className="draft-confirmation">
          <img src="/themes/custom/tink/dist/assets/icon-confirmation.svg" alt="" className='icon-confirmation' />
          <p dangerouslySetInnerHTML={{__html: window.Drupal.t('fournisseur.creation_form.confirmation.draft.content')}}></p>


          <div className="action-buttons">
            <div className="text-center">
              <button onClick={() => handleClickLinks(urlActivityDetail, 'activity', form?.REDU_Activity_Id)} className="button btn-larger" type="button">
                {window.Drupal.t('fournisseur.creation_form.form.details')}
              </button>
            </div>
            <div className="text-center">
              <button onClick={() => handleClickLinks(urlHome)} className="button btn-outlined btn-larger" type="button">
                {window.Drupal.t('fournisseur.creation_form.form.backhome')}
              </button>
            </div>
          </div>
        </div>
      </div>

    </main >
  );
}

FournisseurRecognitionRequestStepFourConfirmBlock.propTypes = {
  hasPreviousRenewalEndDate: PropTypes.bool,
  currentStep: PropTypes.number.isRequired,
  onStepChange: PropTypes.func,
  accessToken: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  apiEnv: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  urlActivityDetail: PropTypes.string.isRequired,
  urlHome: PropTypes.string.isRequired,
}
